/* Keepin' It Halal Brand - fetch product recommendations and swap in the rendered section. */
(function () {
  function load(el) {
    var url = el.dataset.url;
    if (!url || el.dataset.performed !== undefined) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-kih="recs"]');
        if (fresh && fresh.innerHTML.trim().length) {
          el.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () {});
  }
  function boot() { document.querySelectorAll('[data-kih="recs"]').forEach(load); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
